const InstructionActions = ({ instruction, onPreview }) => <div className="aluminium-instruction-actions">
  <button
    type="button"
    className="aluminium-instruction-button"
    onClick={() => onPreview(instruction)}
    disabled={!instruction.url}
    title={instruction.url ? `Podgląd: ${instruction.title}` : 'Instrukcja zostanie dodana później'}
  >
    📖 Podgląd instrukcji
  </button>
  {instruction.url
    ? <a className="aluminium-instruction-download" href={instruction.url} download={instruction.filename}>⬇ Pobierz instrukcję PDF</a>
    : <button type="button" className="aluminium-instruction-download" disabled title="Instrukcja zostanie dodana później">⬇ Pobierz instrukcję PDF</button>}
</div>;

export default InstructionActions;
